/**
 * @desc 保存角色权限
 */

import * as defs from '../../baseClass';
import { defHttp } from 'hailuo-http';
export interface Params {}

export function request(
  data: defs.RolePermissionRequest,
): Promise<defs.StandardReturn<void>> {
  return defHttp.post({
    url: '/wap/rolePermission/saveRolePermissions',
    data,
  });
}

export function mock(
  data: defs.RolePermissionRequest,
): Promise<defs.StandardReturn<void>> {
  return defHttp.post({
    url: '/mock/wap/rolePermission/saveRolePermissions',
    data,
  });
}
